import { ROUTE_PATH } from "common/constants/sm-constants";
import { MetaModel } from "common/models/utility-models/base-model";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";
import { CreditFilterMetaModel } from "./credit-filter-meta-model";

export class CreditReportsGridMetaModel extends GridMetaModel<Headers> {
    filterMeta = new CreditFilterMetaModel().getMetaModel();
    constructor() {
        super(
            'Credit Reports',
            ROUTE_PATH.reports,
            ROUTE_PATH.reports,
            false,
            false,
            8,
            false,
            false,
            ['orgname'],
            false,
            [],
            { isDownloadExcel: true, excelFileName: 'Credit Reports_' + new Date().toLocaleDateString() +'.xlsx', btnLabel: 'Download Credit Report', headers: [{ key: 'StudentName', value: 'orgname' }, { key: 'CollegeName', value: 'name_of_college' }, { key: 'Branch', value: 'branch_name' }, { key: 'Year 1', value: 'first_year_credit' }, { key: 'Year 2', value: 'second_year_credit' }, { key: 'Year 3', value: 'third_year_credit' }, { key: 'Year 4', value: 'fourth_year_credit' },{ key: 'TotalPercent', value: 'creditTotal' }, { key: 'Status', value: 'statusType' }] },
            false,
            null,
            false,
            false,
            false,
            null,
            { evalKey: 'isDeletable', evalParam: [1], decisiveParam: false },
            false,
            null,
            {
                isPreview: false,
                isPreviewType: 'VIDEO',
                isEnvUrl: false,
                linkKey: ['filePath'],
                previewName: ''
            },
            {
                isTabSwitch: false,
                label: '',
                isChecked: false
            },
            true,
            true,
            true,
            [{ label: '', colspan: '1', class: '' }, { label: '', colspan: '1', class: '' }, { label: 'Credit Score (Year Wise)', colspan: '8', class: "text-center px-2" }],
            false,
            { isExtraActions: false, btnLabel: '' },
            {isCheckboxEmit: false, emitKey: '', checkedKey: '', valueKey: ''},
        )
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const studentName = new Headers('Student Name', 'orgname', false, false, 'text');
        const collegeName = new Headers('College Name', 'name_of_college', false, false, 'text');
        const branch = new Headers('Branch', 'branch_name', false, false, 'text');
        const first_year_credit = new Headers('Year 1', 'first_year_credit', false, false, 'text');
        const second_year_credit = new Headers('Year 2', 'second_year_credit', false, false, 'text');
        const third_year_credit = new Headers('Year 3', 'third_year_credit', false, false, 'text');
        const fourth_year_credit = new Headers('Year 4', 'fourth_year_credit', false, false, 'text');
        const overallKtStatus = new Headers('KT', 'isKT', false, false, 'text');
        const creditTotal = new Headers('Avg Credit score','creditTotal', false, true, 'text','0');
        // const scoreTotal = new Headers('Total (%)', 'scoreTotal', false, false, 'text');
        const statusType = new Headers('Status', 'statusType', false, false, 'text');

        headers.push(studentName);
        headers.push(collegeName);
        headers.push(branch);
        headers.push(first_year_credit);
        headers.push(second_year_credit);
        headers.push(third_year_credit);
        headers.push(fourth_year_credit);
        headers.push(overallKtStatus);
        headers.push(creditTotal);
        // headers.push(scoreTotal);
        headers.push(statusType);

        return headers;
    }

    override getMetaModel(): MetaModel {
        const pageData = new MetaModel();
        pageData.pageTitle = this.pageTitle;
        pageData.properties = this.initProperties();
        pageData.redirectPath = this.redirectPath;
        pageData['filterMeta'] = this.filterMeta;
        return pageData;
      }
}